import React, { useState } from 'react';
import { verifyPassword } from '../utils/auth';
import './LoginForm.css';

interface LoginFormProps {
  onSuccess?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    const result = await verifyPassword(password);

    if (result.success) {
      setMessage({ type: 'success', text: 'Inloggen gelukt!' });
      setTimeout(() => {
        onSuccess?.();
      }, 300);
    } else {
      setMessage({ type: 'error', text: result.message || 'Ongeldig wachtwoord' });
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="https://www.hvglaw.nl/wp-content/uploads/logo-in-browser-balk-3.jpg" 
            alt="HVG Law Logo" 
            className="hvg-logo"
            style={{ height: '60px', width: 'auto', marginBottom: '16px' }}
          />
          <h1>Org. Chart Generator</h1>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">Wachtwoord</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Voer het wachtwoord in"
              required
              disabled={loading}
              autoFocus
              className="email-input"
            />
          </div>

          {message && (
            <div className={`message ${message.type}`}>
              {message.text}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className="login-button"
          >
            {loading ? 'Bezig...' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;

